import { useEffect, useState } from "react";

import { api } from "../lib/api";
import { logError } from "../lib/errors";

const DEFAULT_CALL_NAME = "あなた";
const PREFERRED_NAME_KEY = "name";

export function usePreferredCallName() {
  const [callName, setCallName] = useState(DEFAULT_CALL_NAME);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const profiles = await api.getUserProfile();
        const preferredName =
          profiles.find((item) => item.key === PREFERRED_NAME_KEY)?.value.trim() ?? "";

        if (active) {
          setCallName(preferredName || DEFAULT_CALL_NAME);
        }
      } catch (error) {
        logError(error);
        if (active) {
          setCallName(DEFAULT_CALL_NAME);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return callName;
}
